import React, { FC, useMemo } from 'react';
import { useHistory } from 'react-router';

import { Column, DataGrid, Export, MasterDetail, Summary, TotalItem } from 'devextreme-react/data-grid';

import { Workbook } from 'exceljs';

import { Button, Template } from 'devextreme-react';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';
import $createStore from 'utils/create-store-instance';

import { useLazyGetShiftDispatcherReportExcelQuery } from 'bus/shift/services/services';

import DetailTemplate from './SecondaryDetailTemplate';

const Detail: FC<any> = (props) => {
  const history = useHistory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const shiftDateSource: any = useMemo(() => $createStore(`/v1/Shift/${props.data.data.id}`, 'requestId'), []);

  const [getDispatcherReportExcel] = useLazyGetShiftDispatcherReportExcelQuery();

  const onExporting = () => {
    getDispatcherReportExcel({ id: props.data.data.id });
  };

  const onExportingLocal = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('1');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
    e.cancel = true;
  };

  const dbClickOnRowHandler = (id: number | string) => {
    history.push(`/task/detail-arch/${id}`);
  };

  return (
    <React.Fragment>
      <DataGrid
        dataSource={shiftDateSource}
        showBorders={true}
        columnAutoWidth={true}
        onExporting={onExportingLocal}
        onRowDblClick={(e) => dbClickOnRowHandler(e.key)}
        onToolbarPreparing={(e) => {
          e.toolbarOptions?.items?.unshift({
            location: 'after',
            template: 'xlsfile',
          });
        }}
      >
        <Template name="xlsfile">
          <Button icon="xlsfile" onClick={onExporting} text="" hint="Отчет" />
        </Template>
        <Column dataField="requestId" caption="Номер заявки" width={120} />
        <Column dataField="date" caption="Дата" dataType="datetime" />
        <Column dataField="contractor" caption="Контрагент" />
        <Column dataField="nomenclature" caption="Номенклатура" />
        <Column dataField="requestQuantity" caption="Объем по заявке" dataType="number" />
        <Column dataField="shipped" caption="Отгружено" dataType="number" />
        <Column dataField="fault" caption="Погрешность отгрузок" dataType="number" />

        <MasterDetail enabled={true} component={DetailTemplate} />

        <Summary>
          <TotalItem
            column="shipped"
            summaryType="sum"
            displayFormat="{0}"
            //customizeText={(data: any) => `Итого: ${data.value}`}
          />
          <TotalItem
            column="fault"
            summaryType="sum"
            displayFormat="{0}"
            customizeText={(data: any) => `${data.value.toFixed(2)}`}
          />
        </Summary>
        <Export enabled={true} />
      </DataGrid>
    </React.Fragment>
  );
};

export default Detail;
